/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ClosedEnum } from "../types/enums.js";

export type PostImageMotouFile = {
  fileName: string;
  content: Uint8Array | string;
};

export const PostImageMotouFile$zodSchema: z.ZodType<PostImageMotouFile> = z
  .object({
    content: z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    fileName: z.string(),
  });

/**
 * GIF的背景颜色。可选值为 'white', 'black', 'transparent'。
 */
export const PostImageMotouBgColor = {
  White: "white",
  Black: "black",
  Transparent: "transparent",
} as const;
/**
 * GIF的背景颜色。可选值为 'white', 'black', 'transparent'。
 */
export type PostImageMotouBgColor = ClosedEnum<typeof PostImageMotouBgColor>;

export const PostImageMotouBgColor$zodSchema = z.enum([
  "white",
  "black",
  "transparent",
]).describe("GIF的背景颜色。可选值为 'white', 'black', 'transparent'。");

/**
 * 包含图片来源和背景色的表单数据。必须提供 'image_url' 或 'file' 两者之一。
 */
export type PostImageMotouRequest = {
  image_url?: string | undefined;
  file?: PostImageMotouFile | Blob | undefined;
  bg_color?: PostImageMotouBgColor | undefined;
};

export const PostImageMotouRequest$zodSchema: z.ZodType<PostImageMotouRequest> =
  z.object({
    bg_color: PostImageMotouBgColor$zodSchema.optional(),
    file: z.lazy(() => PostImageMotouFile$zodSchema).optional(),
    image_url: z.string().optional(),
  }).describe(
    "包含图片来源和背景色的表单数据。必须提供 'image_url' 或 'file' 两者之一。",
  );

/**
 * 服务器内部错误。可能的原因包括：从URL获取图片失败、处理上传文件失败，或在生成GIF过程中发生错误。
 */
export type PostImageMotouInternalServerErrorResponseBody = {
  error?: string | undefined;
};

export const PostImageMotouInternalServerErrorResponseBody$zodSchema: z.ZodType<
  PostImageMotouInternalServerErrorResponseBody
> = z.object({
  error: z.string().optional(),
}).describe(
  "服务器内部错误。可能的原因包括：从URL获取图片失败、处理上传文件失败，或在生成GIF过程中发生错误。",
);

/**
 * 请求参数错误。必须提供 'image_url' 或上传 'file' 文件两者中的一个。
 */
export type PostImageMotouBadRequestResponseBody = {
  error?: string | undefined;
};

export const PostImageMotouBadRequestResponseBody$zodSchema: z.ZodType<
  PostImageMotouBadRequestResponseBody
> = z.object({
  error: z.string().optional(),
}).describe(
  "请求参数错误。必须提供 'image_url' 或上传 'file' 文件两者中的一个。",
);

export type PostImageMotouResponse =
  | Uint8Array
  | string
  | PostImageMotouBadRequestResponseBody
  | PostImageMotouInternalServerErrorResponseBody;

export const PostImageMotouResponse$zodSchema: z.ZodType<
  PostImageMotouResponse
> = z.union([
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.lazy(() => PostImageMotouBadRequestResponseBody$zodSchema),
  z.lazy(() => PostImageMotouInternalServerErrorResponseBody$zodSchema),
]);
